'use client';

import { Container, Subtitle } from './error-message.elements';
import { Title } from '@/styles/global.elements';
import { Button } from '@/elements/button/button.component';

const ErrorMessage = () => {
  // Hard reload — router.refresh() only re-runs the same failing RSC render,
  // so inside an error boundary it looks like the button does nothing.
  return (
    <Container>
      <Title>Oops, dogodila se greška.</Title>
      <Subtitle>Provjeri poveznicu koja te dovela ovdje. Možda ima grešku.</Subtitle>
      <Button alignSelf="center" onClick={() => window.location.reload()}>
        Osvježi stranicu
      </Button>
    </Container>
  );
};

export { ErrorMessage };
